(function(e) {
    var lang = document.documentElement.lang;
    var btns = document.querySelectorAll('.klaviyo_form_trigger');
    btns.forEach(btn => {
      btn.addEventListener('click', function (event){
        event.preventDefault();
        if(lang == 'fr'){
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'TbE6fS']);
           console.log(window._klOnsite)
        }else {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'WsM7ps']);
        }
      });
    });
})();